import React from "react";

import { MenuItemEditor } from "features/MenuItemEditor";
import { PageTitle } from "shared/ui";

const EditMenuItemPage = () => {
    return (
        <>
            <PageTitle>Редактирование</PageTitle>
            <MenuItemEditor />
        </>
    );
};

export default EditMenuItemPage;
